import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
axios.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message === 'Unauthenticated.'
    ) {
      const modalEl = document.getElementById('sessionExpiredModal')
      if (modalEl) {
        // Bootstrap est chargé via CDN donc accessible en global
        // @ts-ignore
        const bsModal = new bootstrap.Modal(modalEl)
        // bsModal.show()

        const btn = document.getElementById('modalLogoutBtn')
        btn?.addEventListener(
          'click',
          () => {
            localStorage.removeItem('user_zgh')
            store.dispatch('auth/logout')
            router.push('/')
            bsModal.hide()
          },
          { once: true }
        )
      }


      localStorage.removeItem('user_zgh')
      router.push('/')
    }
    return Promise.reject(error)
  }
)

createApp(App).use(store).use(router).mount('#app')
